module.exports = __webpack_public_path__ + "static/img/paulina.d854fbf.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/paulina.jpeg
// module id = JPNI
// module chunks = 1